export const common = {
  // Navigation
  home: "Accueil",
  features: "Avantages clés",
  cases: "Études de cas", 
  pricing: "Nos tarifs",
  about: "À propos de nous",
  getStarted: "Commencer",
  language: "Français",

  // Common Actions
  contactUs: "Nous contacter",
  viewFaq: "Voir la FAQ",

  // Hero Section
  heroSubtitle: "Flidge, votre partenaire de localisation de jeux vidéo de référence",
  heroTitle1: "Permettez aux joueurs du monde entier de",
  heroTitle2: "découvrir pleinement votre jeu",
  heroDescription: "Grâce à une technologie d'IA de pointe, nous offrons aux développeurs des solutions de traduction multilingues précises, rapides et économiques, et les aidons à accéder aux opportunités du marché mondial des joueurs",
  learnMore: "Voir nos avantages",
  freeTrial: "Essai gratuit",
  socialProof: "Choisi par plus de 80 développeurs et éditeurs de jeux",
  
  // Features Section
  featuresSubtitle: "Avantages clés",
  featuresTitle: "Solution efficace de localisation de jeux",
  
  feature1Title: "Efficacité et rapidité",
  feature1Description: "Réalisez des traductions précises et de haute qualité dans des délais plus courts : un projet de 200 000 caractères peut être traduit en seulement 1 jour. Améliorez considérablement l'efficacité de la localisation de vos projets de jeux. Comparé à la traduction humaine traditionnelle, notre solution réduit significativement les erreurs humaines et identifie avec précision les différences de casse et de ponctuation. La qualité de traduction est certifiée par des agences de traduction professionnelles.",
  
  feature2Title: "Multilingue et multiscénario", 
  feature2Description: "Nous proposons des services de traduction dans 64 langues à travers le monde : scripts et dialogues de jeu, fiches produit, titres de jeux, glossaires, sites web officiels et bien plus encore. Une solution complète pour tous vos besoins de localisation.",

  // Feature 2 Additional
  glossary: "Glossaire",
  gameTermsReference: "Glossaire des termes du jeu",
  storePage: "Page du store",
  storePageDesc: "Nom du jeu, description, points forts, slogans promotionnels",
  gameStoryTranslation: "Traduction narrative de jeu",
  gameStoryDesc: "Quêtes principales et secondaires",
  completed: "Terminé",
  inProgress: "En cours",
  pending: "En attente",

  feature3Title: "Support de formats variés",
  feature3Description: "Importez et exportez dans de multiples formats texte pour intégrer facilement vos traductions dans vos projets de jeu. Compatible avec tous les moteurs de jeu, l'intégration est simple et efficace.",
  
  feature4Title: "Une localisation par de vrais experts du jeu vidéo",
  feature4Description: "Spécialisé dans la localisation de jeux vidéo, avec une compréhension approfondie des besoins spécifiques aux textes de jeu, dialogues, interfaces et d'autres contextes variés. Doté d'un riche glossaire de jeu vidéo, assurant une localisation authentique pour permettre aux joueurs de mieux comprendre votre jeu.",
  
  // Feature 4 Additional
  professionalGlossary: "Glossaire professionnel",
  professionalTerminologyDatabase: 'Glossaires spécialisés',
  cheese: 'Cheese',
  feeding: 'Feeding',
  rush: 'Rush',
  balance: 'Balance',
  fightingGamesJapanese: 'Jeux de combat - Japonais',
  mobaGamesKorean: 'Jeux MOBA - Coréen',
  starcraftRussian: 'StarCraft - Russe',
  actionGamesChinese: "Jeux d'action - Chinois",
  more: "Plus",
  
  // Features Section Additional
  translationTimeComparison: "Comparaison du temps de traduction",
  basedOnProject: "Basé sur un projet de 200 000 caractères",
  traditionalAgency: "Agences traditionnelles",
  aiPlatform: "Service de traduction IA Flidge",
  days: " jours",
  day: " jour",
  hours: " heures",
  hour: " heure",
  "10days": "10 jours",
  "1day": "1 jour",
  "240hours": "240 heures", 
  "24hours": "24 heures",

  // Case Studies Section
  casesSubtitle: "Études de cas",
  casesTitle: "Faire découvrir les jeux indépendants aux joueurs du monde entier",
  casesDescription: "Nous valorisons chaque opportunité de collaboration, et notre mission est de faire découvrir davantage de jeux indépendants à plus de joueurs dans le monde entier",
  
  // Game Types
  platformActionGame: "Jeu d'action-plateforme",
  musicRhythmGame: "Jeu de rythme",
  actionStealthGame: "Jeu d'action-infiltration",
  casualPuzzleGame: "Jeu de réflexion casual",
  roguelikeCardGame: "Jeu de cartes stratégique Roguelike",
  simulationGame: "Jeu de gestion",
  
  // Game Descriptions
  haakDescription: "Traduction du metroidvania HAAK en 14 langues : +147 % de ventes mensuelles",
  museDashDescription: "Traduction de Muse Dash en japonais, coréen et anglais, offrant une expérience localisée de qualité à des millions de joueurs",
  kristalaDescription: "Traduction chinoise pour le jeu d'action-infiltration Kristala, y compris la traduction du nom du jeu et de sa page sur la boutique",
  lazyMeowDescription: "Localisation en anglais, japonais et coréen du jeu de réflexion casual Lazy Meow City, facilitant sa percée sur le marché Asie-Pacifique",
  stoneSquadDescription: "30 langues disponibles pour StoneSquad : anglais, japonais, coréen, portugais, espagnol, et plus encore",
  catHotelDescription: "Services de traduction pour CatHotel (anglais, japonais, chinois simplifié et traditionnel) couvrant scénarios, quêtes, objets et pages de boutique, pour une expérience de jeu véritablement localisée",
  
  // Results
  monthlyRevenueGrowth: "147% de croissance des revenus mensuels",
  playerReviews: "Critiques positives des joueurs",
  translationCompleted: "Traduction terminée",
  salesIncrease: "Augmentation des ventes",
  exposureGrowth: "Croissance de l'exposition",
  playerReviews2: "Critiques positives des joueurs",
  result: "Résultat",
  customerReviews: 'Avis clients',
  realUserFeedback: 'Retours d\'utilisateurs réels',
  
  // Pricing Section
  pricingSubtitle: "Nos tarifs",
  pricingTitle: "Une tarification transparente",
  pricingDescription: "Nous proposons des formules tarifaires flexibles adaptées aux projets de toutes tailles. Chaque client bénéficie d'un crédit d'essai gratuit.",
  
  freeTrialTitle: "Crédit d'essai gratuit",
  standardPricing: "Tarification standard",
  standardPricingDescription: "Tarif standard après dépassement du quota gratuit",
  standardPricingFeatures: {
    languages: "Traduction en 64 langues",
    speed: "Traduction de 200 000 caractères en 24 heures",
    formats: "Prise en charge de multiples formats de fichiers",
    glossary: "Terminologie spécialisée jeux vidéo",
    quality: "Services de garantie de qualité et de révision"
  },
  customPrice: "Personnalisé",
  customPlan: "Tarifs",
  customPlanDescription: "Prix avantageux pour projets de grande envergure",
  
  // Enterprise Features
  enterpriseCustom: "Offre entreprise personnalisée",
  recommended: "Recommandé",
  perCharacter: "Par caractère",
  perLanguage: "Par langue",
  startUsing: "Commencer maintenant",
  contactBusinessTeam: "Contacter les ventes",
  
  enterpriseFeatures: {
    allStandard: "Inclut toutes les fonctionnalités de la version standard",
    manager: "Chargé de clientèle dédié",
    priority: "Support prioritaire et traitement accéléré",
    customGlossary: "Glossaires et guides de style personnalisés",
    discount: "Remises sur volume et offres de partenariat à long terme",
    extraTrial: "Demander des crédits d'essai supplémentaires"
  },

  // Pricing Section Additional
  languagesCount: "Langues",
  freeExperience: "Essai gratuit", 
  freeTrialDescription: "Chaque organisation partenaire dispose d'un quota d'essai gratuit de 5000 caractères pour une seule langue cible, vous permettant d'évaluer pleinement la qualité de nos traductions",
  
  // New Pricing Calculator Section
  priceCalculator: "Calculateur de prix",
  calculatorDescription: "Estimez rapidement le coût de traduction de votre projet",
  charactersCount: "Nombre de caractères",
  targetLanguagesCount: "Nombre de langues cibles",
  estimatedCost: "Coût estimé",
  
  calculationNotes: "Explication du calcul",
  calculationDetails: {
    freeQuota: "Chaque partenaire bénéficie d'un quota gratuit de 5 000 caractères (pour une seule langue)",
    pricing: "Au-delà du quota gratuit : 0,011 $/caractère/langue",
    bulkDiscount: "Tarification personnalisée pour les projets d'envergure",
    finalPrice: "Le tarif final sera confirmé par notre équipe commerciale"
  },

  // About Section
  aboutSubtitle: "À propos de nous",
  aboutTitle: "Équipe spécialisée en localisation de jeux",
  aboutDescription: "Fondée en 2019, Flidge est une entreprise technologique spécialisée dans la localisation de jeux vidéo. En combinant l'intelligence artificielle et la révision professionnelle humaine, nous offrons aux développeurs de jeux du monde entier des services de localisation multilingue de haute qualité et d'une grande efficacité, permettant aux jeux exceptionnels de toucher le marché mondial.",
  
  ourMission: "Notre mission",
  ourVision: "Notre vision",
  missionText: "Grâce à des technologies d'IA avancées et à des services de localisation professionnels, nous brisons les barrières linguistiques pour permettre à chaque jeu exceptionnel de réussir sur le marché mondial et offrir aux joueurs du monde entier des expériences de jeu captivantes.",
  visionText: "Devenir la plateforme leader mondiale de localisation de jeux vidéo, contribuer à l'expansion internationale de l'industrie par l'innovation technologique et l'expertise professionnelle, et permettre aux meilleures créations vidéoludiques de rayonner partout dans le monde.",
  
  // FAQ Section
  faqSubtitle: 'Questions fréquentes',
  faqTitle: 'Foire aux questions',
  faqDescription: 'Si vous avez plus de questions, n\'hésitez pas à nous contacter à tout moment',
  stillHaveQuestions: "Encore des questions ?",
  
  faqQuestion1: 'Pouvez-vous fournir un quota de traduction d\'essai ?',
  faqQuestion2: 'À quel stade du développement est-il recommandé de commencer à utiliser les services de Flidge ?',
  faqQuestion3: 'Que faire si mon projet de jeu n\'a pas de glossaire ?',
  faqQuestion4: 'Le contenu de mon jeu sera-t-il strictement confidentiel ?',
  
  // FAQ Items
  faq1Question: "Puis-je tester le service gratuitement ?",
  faq1Answer: "Nous offrons à chaque partenaire un crédit d'essai gratuit de 5 000 caractères pour la traduction dans une langue. Au-delà, le tarif est de 0,016 USD par caractère et par langue cible. Pour obtenir un crédit d'essai supplémentaire, veuillez contacter notre équipe commerciale.",
  
  faq2Question: "À quel stade du développement est-il recommandé de commencer à utiliser les services de Flidge ?",
  faq2Answer: "Nous recommandons d'utiliser les services de Flidge durant les phases intermédiaires à avancées du développement de votre projet de jeu. Cela vous permettra d'optimiser au maximum vos coûts de localisation. Nous pouvons également vous accompagner dans la traduction de votre page boutique et vous aider à identifier les noms localisés les plus adaptés pour votre jeu, afin que les joueurs puissent s'en souvenir plus facilement et vous permettre de mieux conquérir le marché mondial.\nSi votre jeu est sur le point d'être publié sur des plateformes comme Steam, les services de Flidge sont parfaitement adaptés à vos besoins. Nous pouvons localiser votre jeu dans de nombreuses langues en un temps record, permettant ainsi aux joueurs du monde entier de découvrir votre jeu.",
  
  faq3Question: "Que faire si mon projet de jeu n'a pas de glossaire ?",
  faq3Answer: "Nous pouvons vous proposer un service de gestion de glossaire via Flidge AI pour vous aider à mieux gérer votre projet et le contenu à traduire. Nous vérifierons et validerons avec vous l'utilisation des termes afin de garantir qu'ils soient utilisés correctement dans votre jeu.\nSi ce service vous intéresse, n'hésitez pas à nous contacter.",
  
  faq4Question: "Le contenu de mon jeu sera-t-il strictement confidentiel ?",
  faq4Answer: "Nous appliquons un chiffrement conforme aux standards de l'industrie et des workflows cloisonnés spécifiquement conçus pour les projets vidéoludiques. Chaque membre de l'équipe travaille sous un accord de confidentialité strict avec une responsabilité financière clairement définie. Notre environnement de développement garantit une isolation totale des actifs : aucune capture d'écran, aucun disque externe, aucun appareil personnel. Nous savons qu'une fuite d'images, d'éléments narratifs ou de dates de sortie peut compromettre l'impact commercial d'un jeu. Votre propriété intellectuelle créative bénéficiera de la même protection que nous appliquons à nos propres projets non publiés.",
  
  // CTA Section
  ctaTitle1: "Faites aimer votre jeu",
  ctaTitle2: "au monde entier",
  
  // Contact Section
  contactSubtitle: "Nous contacter",
  contactTitle: "Bénéficiez de services de traduction professionnels et de crédits d'essai gratuits",
  contactDescription: "Remplissez le formulaire ci-dessous et notre équipe d'experts vous proposera une solution détaillée dans les 24 heures",
  
  name: "Nom",
  email: "Email",
  company: "Nom de l'entreprise ou du studio",
  targetLanguages: "Langue(s) cible(s)",
  projectDetails: "Détails du projet",
  getQuote: "Obtenir un devis",
  onlineConsult: "Consultation en ligne",
  emailContact: "Nous contacter",
  
  // Footer
  footerDescription: "Nous aidons les jeux indépendants à conquérir le marché mondial grâce à des services de localisation efficaces et abordables : traduction intelligente, analyse et solutions linguistiques sur mesure.",
  services: "Services",
  companySection: "Entreprise",
  resources: "Ressources",
  featuresLink: "Avantages clés",
  pricingConsult: "Nos tarifs",
  aboutUs: "À propos de nous",
  helpCenter: "Centre d'aide",
  techBlog: "Blog technique",
  termsOfService: "Conditions d'utilisation",
  privacyPolicy: "Politique de confidentialité",
  cookiePolicy: "Politique de cookies",
  poweredBy: "Powered by Readdy",
  copyright: "© 2025 Flidge AI Service de traduction. Tous droits réservés.",
  
  // Form labels
  required: "*",
  characterCount: "caractères",
  
  // Form placeholders
  namePlaceholder: "Veuillez entrer votre nom",
  emailPlaceholder: "Veuillez entrer votre adresse email",
  companyPlaceholder: "Veuillez entrer le nom de l'entreprise ou du studio",
  languagesPlaceholder: "ex : Anglais, Japonais, Coréen, etc.",
  messagePlaceholder: "Veuillez décrire en détail vos exigences de projet, y compris le type de jeu, le contenu de traduction, les exigences spéciales, etc...",
  
  // Alt texts
  gameIcon: "Icône de jeu",
  flidgeLogo: "Logo Flidge",
  abstractShape: "Forme abstraite",
  
  // Testimonials
  testimonialSarahRole: "Développeuse de jeux indépendants",
  testimonialSarahContent: "Depuis que nous utilisons Flidge, nos jeux sont très bien accueillis sur les marchés internationaux. La qualité de traduction dépasse largement nos attentes, et les joueurs nous disent que la narration est parfaitement rendue, rien à voir avec une traduction automatique.",
  
  testimonialThijsRole: "Directeur de studio de jeu",
  testimonialThijsContent: "De la traduction initiale du scénario à l'optimisation ultérieure des textes, l'équipe Flidge a fait preuve d'un professionnalisme exemplaire. Leur compréhension de la culture vidéoludique a rendu le processus de localisation bien plus fluide.",
  
  testimonialEmmaRole: "Gestionnaire de localisation de jeu",
  testimonialEmmaContent: "Les services de traduction de Flidge nous ont fait économiser énormément de temps et d'argent. Leur technologie IA est non seulement rapide, mais elle comprend avec précision la terminologie spécialisée et les nuances culturelles des jeux.",
  
  testimonialDavidRole: "Producteur de jeu",
  testimonialDavidContent: "Nos jeux ont connu un immense succès sur les marchés japonais et coréen, et c'est grâce aux services de localisation de qualité fournis par Flidge. Leur compréhension approfondie des cultures est-asiatiques rend les traductions vraiment authentiques.",
  
  testimonialAlexRole: "Développeur indépendant",
  testimonialAlexContent: "En tant que petite équipe, notre plus grande crainte concernait les coûts de localisation. Flidge propose non seulement des tarifs raisonnables, mais travaille aussi avec une efficacité remarquable, nous permettant d'accéder simultanément à plusieurs marchés internationaux.",
  
  testimonialYukiRole: "Planificateur de jeu",
  testimonialYukiContent: "La compréhension de Flidge pour la culture du jeu japonais m'a vraiment impressionné. Ils n'ont pas simplement traduit les mots, ils ont su transmettre l'esprit même du jeu, permettant aux joueurs internationaux de vivre une expérience authentique.",
  
  abstractShape2: "Forme abstraite 2",

  // New entries from modification
  partners: "Partenaires",
  trustedPartners: "Partenaires de confiance",
  partnersDescription: "Partenariats approfondis et durables avec les meilleures équipes de jeux et entreprises mondiales",

  gameProjectsServed: "Entreprises accompagnées",
  supportedLanguages: "Langues disponibles",
  clientSatisfaction: "Satisfaction client",
  responseTime: "Délai de réponse",

  // Additional Metrics
  translatedCharactersCount: "5M+",
  avgTranslationSpeedValue: "3,2 s",
  translatedCharacters: "Volume de traduction",
  avgTranslationSpeed: "Temps moyen par 1000 caractères",
  clientSatisfactionRate: "Taux de satisfaction client",
  servicedCompanies: "Clients accompagnés",
  successMetrics: "Indicateurs de réussite",
  serviceImpact: "Impact des services",

  // Statistics
  stat1Number: '80+',
  stat1Label: 'Entreprises accompagnées',
  stat2Number: '64',
  stat2Label: 'Langues disponibles',
  stat3Number: '97%',
  stat3Label: 'Satisfaction client',
  stat4Number: '24h',
  stat4Label: 'Délai de réponse',

  // Terms of Service
  termsTitle: 'Conditions de Service',
  termsLastUpdated: 'Dernière mise à jour : Janvier 2025',
  terms1Title: '1. Acceptation des Conditions',
  terms1Content: 'En accédant et en utilisant les Services de Traduction AI de Flidge, vous acceptez et convenez d\'être lié par les termes et dispositions de cet accord.',
  terms2Title: '2. Licence d\'Utilisation',
  terms2Content: 'La permission est accordée de télécharger temporairement une copie des matériaux sur le site web de Flidge pour un usage personnel et non commercial uniquement.',
  terms3Title: '3. Clause de Non-Responsabilité',
  terms3Content: 'Les matériaux sur le site web de Flidge sont fournis "en l\'état". Flidge ne fait aucune garantie expresse ou implicite.',
  terms4Title: '4. Limitations',
  terms4Content: 'En aucun cas Flidge ou ses fournisseurs ne seront responsables de tout dommage résultant de l\'utilisation ou de l\'incapacité d\'utiliser les matériaux.',
  terms5Title: '5. Exactitude des Matériaux',
  terms5Content: 'Les matériaux apparaissant sur le site web de Flidge pourraient inclure des erreurs techniques, typographiques ou photographiques.',
  terms6Title: '6. Liens',
  terms6Content: 'Flidge n\'a pas examiné tous les sites liés à notre site web et n\'est pas responsable du contenu de ces sites.',
  terms7Title: '7. Modifications',
  terms7Content: 'Flidge peut réviser ces conditions de service à tout moment sans préavis.',
  terms8Title: '8. Loi Applicable',
  terms8Content: 'Ces termes et conditions sont régis et interprétés conformément aux lois applicables.',

  // Privacy Policy
  privacyTitle: 'Politique de Confidentialité',
  privacyLastUpdated: 'Dernière mise à jour : Janvier 2025',
  privacy1Title: '1. Informations que Nous Collectons',
  privacy1Content: 'Nous collectons les informations que vous nous fournissez directement, comme lorsque vous créez un compte ou utilisez nos services de traduction.',
  privacy2Title: '2. Comment Nous Utilisons Vos Informations',
  privacy2Content: 'Nous utilisons les informations collectées pour fournir, maintenir et améliorer nos services de traduction.',
  privacy3Title: '3. Partage d\'Informations',
  privacy3Content: 'Nous ne vendons, n\'échangeons ou ne transférons pas vos informations personnelles à des tiers sans votre consentement.',
  privacy4Title: '4. Sécurité des Données',
  privacy4Content: 'Nous mettons en place des mesures de sécurité appropriées pour protéger vos informations personnelles.',
  privacy5Title: '5. Conservation des Données',
  privacy5Content: 'Nous conservons vos informations personnelles aussi longtemps que nécessaire pour fournir nos services.',
  privacy6Title: '6. Vos Droits',
  privacy6Content: 'Vous avez le droit d\'accéder, de mettre à jour et de demander la suppression de vos informations personnelles.',
  privacy7Title: '7. Cookies et Suivi',
  privacy7Content: 'Nous utilisons des cookies et des technologies de suivi similaires pour améliorer votre expérience sur notre site web.',
  privacy8Title: '8. Transferts Internationaux',
  privacy8Content: 'Vos informations peuvent être transférées et traitées dans des pays autres que le vôtre.',
  privacy9Title: '9. Modifications de Cette Politique',
  privacy9Content: 'Nous pouvons mettre à jour cette Politique de Confidentialité de temps à autre.',
  privacy10Title: '10. Nous Contacter',
  privacy10Content: 'Si vous avez des questions sur cette Politique de Confidentialité, contactez-nous à privacy@flidge.ai.',

  // Cookie Policy
  cookieTitle: 'Politique des Cookies',
  cookieLastUpdated: 'Dernière mise à jour : Janvier 2025',
  cookie1Title: '1. Que sont les Cookies',
  cookie1Content: 'Les cookies sont de petits fichiers texte placés sur votre appareil lorsque vous visitez notre site web.',
  cookie2Title: '2. Types de Cookies que Nous Utilisons',
  cookie2Content: 'Nous utilisons des cookies essentiels pour les fonctions de base du site web, des cookies de performance pour analyser les modèles d\'usage et des cookies fonctionnels.',
  cookie2Essential: 'Cookies Essentiels',
  cookie2EssentialDesc: 'Ces cookies sont nécessaires pour que le site web fonctionne correctement.',
  cookie2Performance: 'Cookies de Performance',
  cookie2PerformanceDesc: 'Ces cookies collectent des informations sur la façon dont les visiteurs utilisent notre site web.',
  cookie2Functional: 'Cookies Fonctionnels',
  cookie2FunctionalDesc: 'Ces cookies permettent au site web de se souvenir des choix que vous faites.',
  cookie3Title: '3. Cookies de Tiers',
  cookie3Content: 'Nous pouvons utiliser des services tiers qui placent des cookies sur votre appareil.',
  cookie4Title: '4. Gestion des Cookies',
  cookie4Content: 'Vous pouvez contrôler et gérer les cookies via les paramètres de votre navigateur.',
  cookie5Title: '5. Consentement aux Cookies',
  cookie5Content: 'En continuant à utiliser notre site web, vous consentez à notre utilisation des cookies comme décrit dans cette politique.',
  cookie6Title: '6. Impact de la Désactivation des Cookies',
  cookie6Content: 'Si vous choisissez de désactiver les cookies, certaines fonctionnalités de notre site web peuvent ne pas fonctionner correctement.',
  cookie7Title: '7. Mises à Jour de Cette Politique',
  cookie7Content: 'Nous pouvons mettre à jour cette Politique des Cookies de temps à autre.',
  cookie8Title: '8. Informations de Contact',
  cookie8Content: 'Si vous avez des questions sur notre utilisation des cookies, contactez-nous à cookies@flidge.ai.'
};

export default common;